import React, { Component } from 'react';
import Loading from '../../../common/Loading';

import FormClaseViolencia from './FormClaseViolencia';
import RedSocialYComunitaria from './FormRedSocialYComunitaria';
import FormAntecedentesViolencia from './FormAntecedentesViolencia';
import FormEfectosActuales from './FormEfectosActuales';
import FromIndicadoresRiesgo from './FormIndicadoresRiesgo';
import FromEstadoSalud from './FormEstadoSalud';
import FormAsociaciones from './FormAsociaciones';
import FormDenunciasAnteriores from './FormDenunciasAnteriores';
import FormDesecadenantesConsulta from './FormDesecadenantesConsulta';
import { graphql, compose } from 'react-apollo';

import insertEvaluacion from '../../../../graphql/mutations/violenciaGenero/insertEvaluacion.graphql';
import agregarEvaluacion from '../../../../graphql/mutations/violenciaGenero/agregarEvaluacion.graphql';
import getUsuario from '../../../../graphql/querys/auth/getUsuario.graphql';
import { Modal, notification } from 'antd';

@compose(
  graphql(insertEvaluacion, {
    name: 'insertEvaluacion',
  }),
  graphql(agregarEvaluacion, {
    name: 'agregarEvaluacion',
  }),
  graphql(getUsuario)
)
class IngresarDatos extends Component {
  state = {
    loading: false,
    step: 0,
    evaluacion: {},
  };

  componentDidMount() {
    // console.log('ENTRE:');
    this.setState(
      {
        idCaso: this.props.match.params.id,
      },
      () => {
        // console.log('STATE: ', this.state);
      }
    );
  }

  onCancel = () => {
    this.setState(
      {
        loading: false,
        step: 0,
      },
      () => {
        this.props.history.push('/');
      }
    );
  };

  recibirEvaluacion = datos => {
    let viejoValor = this.state.evaluacion.valor
      ? this.state.evaluacion.valor
      : 0;
    let nuevoValor = viejoValor + datos.valor;

    this.setState(
      {
        ...this.state,
        evaluacion: {
          ...this.state.evaluacion,
          ...datos,
          valor: nuevoValor,
        },
      },
      () => {
        if (this.state.step === 8) {
          this.guardarEvaluacion();
        } else {
          this.siguientePaso();
        }
      }
    );
  };

  guardarEvaluacion = () => {
    // console.log('LA EVALUACION ES: ', this.state.evaluacion);

    this.props
      .insertEvaluacion({
        variables: {
          evaluacion: this.state.evaluacion,
        },
      })
      .then(respuestaInsert => {
        let idEvaluacion = respuestaInsert.data.insertEvaluacion._id;

        this.props
          .agregarEvaluacion({
            variables: {
              _id: this.state.idCaso,
              idEvaluacion,
            },
          })
          .then(respuestaCaso => {
            if (respuestaCaso.data.agregarEvaluacion) {
              notification.success({
                message: 'Evaluacion agregada correctamente',
                description:
                  'Se asocio correctamente la evaluacion con el caso de violencia',
              });

              this.props.history.goBack();
            } else {
              notification.error({
                message: 'Error',
                description:
                  'No se pudo asociar la evaluacion al caso de violencia',
              });
            }
          })
          .catch(err => {
            console.log(
              'Error a la hora de crear el caso de violencia de genero.'
            );
            console.log(err);

            Modal.error({
              title: 'Error a la hora de crear el caso de violencia de genero',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      })
      .catch(err => {
        console.log('Ocurrio un error a la hora de crear la evaluacion');
        console.log(err);

        Modal.error({
          title: 'Error a la hora de crear la evaluacion',
          content:
            'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
        });
      });
  };

  siguientePaso = () => {
    // console.log("PASO SIGUIENTE");

    //Metodo que se encarga de aumentar en 1 el paso y es llamado por todos los metodos auxiliares
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  };

  anteriorPaso = () => {
    // console.log("PASO ANTERIOR");

    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  };

  render() {
    let { step, loading } = this.state;

    if (loading) {
      return <Loading />;
    }

    return (
      <div>
        {step === 0 && (
          <FormClaseViolencia
            onSubmit={this.recibirEvaluacion}
            onCancel={this.anteriorPaso}
          />
        )}
        {step === 1 && (
          <RedSocialYComunitaria
            onSubmit={this.recibirEvaluacion}
            onCancel={this.anteriorPaso}
          />
        )}

        {step === 2 && (
          <FormAntecedentesViolencia
            onSubmit={this.recibirEvaluacion}
            onCancel={this.anteriorPaso}
          />
        )}

        {step === 3 && (
          <FormEfectosActuales
            onSubmit={this.recibirEvaluacion}
            onCancel={this.anteriorPaso}
          />
        )}

        {step === 4 && (
          <FromIndicadoresRiesgo
            onSubmit={this.recibirEvaluacion}
            onCancel={this.anteriorPaso}
          />
        )}

        {step === 5 && (
          <FromEstadoSalud
            onSubmit={this.recibirEvaluacion}
            onCancel={this.anteriorPaso}
          />
        )}

        {step === 6 && (
          <FormAsociaciones
            onSubmit={this.recibirEvaluacion}
            onCancel={this.anteriorPaso}
          />
        )}

        {step === 7 && (
          <FormDenunciasAnteriores
            onSubmit={this.recibirEvaluacion}
            onCancel={this.anteriorPaso}
          />
        )}

        {step === 8 && (
          <FormDesecadenantesConsulta
            onSubmit={this.recibirEvaluacion}
            onCancel={this.anteriorPaso}
          />
        )}
      </div>
    );
  }
}

export default IngresarDatos;
